import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10.313" height="20" viewBox="0 0 10.313 20">
            <path id="Path_454" data-name="Path 454" d="M8.43-17.68h1.883v-3.18A25.159,25.159,0,0,0,7.57-21C4.855-21,3-19.344,3-16.3v2.8H0v3.555H3V-1H6.668V-9.945H9.543L10-13.5H6.668v-2.449C6.668-16.977,6.953-17.68,8.43-17.68Z" transform="translate(0 21)" fill="#1f1f1f"/>
        </svg>
    );
}